import { Outlet, ScrollRestoration } from 'react-router-dom';
import * as React from 'react';
import { Providers } from './providers';
import { CssBaseline } from '@mui/material';

export function App() {
  return (
    <Providers>
      <CssBaseline />
      <Outlet />
      <ScrollRestoration />
    </Providers>
  );
}

export default App;
